import loopWidgetIndex from '../objects/loop-widget/index.js';
import reviewsIoIndex from '../objects/reviewsio/index.js';
import initRebuyVariants from '../objects/rebuy/rebuy-widgets.js';
import initStaticThumbRail from '../objects/global/product-gallery-thumb-static.js';
import '../objects/plp-buy-form.js';
import '../objects/global/scroll-to-anchor.js'; // UBB-421: single scroll to anchor after layout settles (?scrollto= param from quickview review link)
document.addEventListener('DOMContentLoaded', () => {
  loopWidgetIndex();
  reviewsIoIndex();
  initRebuyVariants();
  initStaticThumbRail();
});
